/*
 * Copyright (c) 2024 Puratos. All rights reserved.
 */

import React from "react";
import {SkeletonSettings} from "../utils/SkeletonSettings";
import ContentLoader from "react-content-loader";

export const AccordionSkeleton = (props) => (
        <div className={"accordion--loading"}>
            <ContentLoader
                height={"100px"}
                width={"90%"}
                speed={SkeletonSettings.SPEED}
                backgroundColor={SkeletonSettings.BACKGROUND}
                foregroundColor={SkeletonSettings.FOREGROUND}
                style={{borderRadius: "10px"}}
                {...props}>
                <rect x="0" y="0" width="100%" height="100%"/>
            </ContentLoader>
            <ContentLoader
                height={"100px"}
                width={"90%"}
                speed={SkeletonSettings.SPEED}
                backgroundColor={SkeletonSettings.BACKGROUND}
                foregroundColor={SkeletonSettings.FOREGROUND}
                style={{borderRadius: "10px"}}
                {...props}>
                <rect x="0" y="0" width="100%" height="100%"/>
            </ContentLoader>
            <ContentLoader
                height={"100px"}
                width={"90%"}
                speed={SkeletonSettings.SPEED}
                backgroundColor={SkeletonSettings.BACKGROUND}
                foregroundColor={SkeletonSettings.FOREGROUND}
                style={{borderRadius: "10px"}}
                {...props}>
                <rect x="0" y="0" width="100%" height="100%"/>
            </ContentLoader>
        </div>
)
